import { render, staticRenderFns } from "./aeAdvisoryNotice.vue?vue&type=template&id=2aa9fb42&scoped=true"
import script from "./aeAdvisoryNotice.vue?vue&type=script&lang=js"
export * from "./aeAdvisoryNotice.vue?vue&type=script&lang=js"
import style0 from "./aeAdvisoryNotice.vue?vue&type=style&index=0&id=2aa9fb42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa9fb42",
  null
  
)

export default component.exports